import { graphql, useStaticQuery } from 'gatsby';

import { useMemo } from 'react';

export const useAllProductsSearch = () => {
    const queryResult = useStaticQuery<{
        [key: string]: { nodes: any[] };
    }>(graphql`
        query UseAllProductsSearch {
            allProductsSearch: allProductsJson {
                nodes {
                    code
                    category
                    images {
                        en_CA
                        fr_CA
                        en_US
                    }
                    slug {
                        en_CA
                        fr_CA
                        en_US
                    }
                    fields {
                        ...productsFieldsImagesFragment
                    }
                    title {
                        en_CA
                        en_US
                        fr_CA
                    }
                    description {
                        en_CA
                        en_US
                        fr_CA
                    }
                    category_localized {
                        en_CA
                        en_US
                        fr_CA
                    }
                    attributes {
                        available_country {
                            values {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                        marque {
                            values {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                    }
                }
            }
        }
    `);

    return useMemo(() => {
        const { allProductsSearch } = queryResult;

        const allProducts = allProductsSearch.nodes.filter((item) => {
            if (
                item.category.startsWith('/Englander/CMS') ||
                item.code.startsWith('englander_')
            ) {
                return false;
            }
            return true;
        });

        return [allProducts] as const;
    }, [queryResult]);
};
